import Button from 'components/General/Button/Button';
import { setFilter, HomeworkSlice, toggleFiltersModal } from '../../HomeworkSlice';
import { useEffect, useState } from 'react';
import { CheckboxGroup } from 'react-rainbow-components';
import { useDispatch, useSelector } from 'react-redux';
import './StatusFilter.scss';

export const StatusFilter = () => {
  const dispatch = useDispatch();
  const homeworkState = useSelector((state: { homework: HomeworkSlice }) => state.homework);
  const [values, setVlaues] = useState<string[] | undefined>(homeworkState.filter.status);

  const handleApplyFilters = () => {
    dispatch(setFilter({ status: values }));
    dispatch(toggleFiltersModal(false));
  };

  const options = [
    { value: 'Active', label: 'Active', disabled: false },
    { value: 'Overdue', label: 'Overdue', disabled: false },
    { value: 'Waiting to be graded', label: 'Waiting to be graded', disabled: false },
    { value: 'Corrected', label: 'Corrected', disabled: false },
  ];

  useEffect(() => {
    setVlaues(homeworkState.filter.status);
  }, [homeworkState.filter.status]);

  return (
    <div className="status-filter-container">
      <h2>Status</h2>
      <div className="filters-container">
        <CheckboxGroup
          options={options}
          value={values}
          onChange={(e) => setVlaues(e)}
          className="checkbox"
        />
      </div>
      <div className="mt-3">
        <Button
          color="primary"
          onClick={handleApplyFilters}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};
